import { Sentry } from './sentryConfig';

export const reportError = (e: Error, context?: Record<string, unknown>) => {
  console.error(e);
  Sentry.captureException(e, {
    extra: context || {},
  });
};

/**
 * Transient RevenueCat error codes that are not actionable by developers.
 * RevenueCat auto-retries purchase failures server-side, so these don't need Sentry tracking.
 * See: https://www.revenuecat.com/docs/test-and-launch/errors
 */
const TRANSIENT_PURCHASE_ERROR_CODES = new Set([
  '2', // STORE_PROBLEM_ERROR - App Store/Play Store connectivity
  '3', // PURCHASE_NOT_ALLOWED_ERROR - Device/account restrictions (parental controls, regional limits)
  '10', // NETWORK_ERROR - Network request failed
  '20', // PAYMENT_PENDING_ERROR - Payment is processing
  '35', // OFFLINE_CONNECTION_ERROR - Device is offline
]);

/** Returns true if a purchase error should be reported to Sentry (i.e., it's not transient). */
export const shouldReportPurchaseError = (errorCode: string | number | undefined): boolean => {
  if (errorCode === undefined || errorCode === null) return true;
  return !TRANSIENT_PURCHASE_ERROR_CODES.has(String(errorCode));
};
